// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconVerified = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M10.878 13.003L16 8v2.796l-5.164 5.044L8 12.899v-2.881z" />,
    <path
      fillRule="evenodd"
      d="M12.817 1.423h-1.634L8.937 4.606 5.1 3.943 3.944 5.1l.662 3.838-3.182 2.246v1.634l3.182 2.246-.662 3.838 1.155 1.155 3.838-.662 2.246 3.182h1.634l2.246-3.182 3.838.662 1.156-1.155-.663-3.838 3.183-2.246v-1.634l-3.183-2.246.663-3.838L18.9 3.943l-3.838.663zm-2.61 4.852L12 3.735l1.793 2.54.987.41 3.065-.53-.53 3.065.41.987L20.264 12l-2.54 1.793-.41.987.53 3.064-3.065-.529-.987.41L12 20.264l-1.793-2.54-.987-.41-3.064.53.529-3.065-.41-.987L3.736 12l2.54-1.793.41-.987-.53-3.065 3.065.53z"
    />
  );
export default SvgIconVerified;
